import { createSelector } from 'reselect';
import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericPost } from '@/_shared/types';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_CONTENTID_END_PATH_KEY } from '@/swagger/constants/contents-orchestrator-keys';
import { KEY_POST_CONTENT_END, API_POST_CONTENT_END } from '../constants';
import { MOCK_RESPONSE_POST_CONTENT_END } from '../mocks';

type API_POST_CONTENT_END_PROPS = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_CONTENTID_END_PATH_KEY
>;

export type RequestPostContentEnd = API_POST_CONTENT_END_PROPS['request']['path'];

export type ResponsePostContentEnd = API_POST_CONTENT_END_PROPS['response']['body'];

export type CallParamsPostContentEnd = Omit<RequestPostContentEnd, 'organizationId'> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

export type CallResponsePostContentEnd = ResponsePostContentEnd;

type CallErrorPostContentEnd = {
  message: string;
  code: number;
  type: string;
  title: string;
  status: number;
};

type CallSelectorsPostContentEnd = {
  data?: CallResponsePostContentEnd;
};

export const postContentEndCall = createGeneralCall<
  CallParamsPostContentEnd,
  CallResponsePostContentEnd,
  CallErrorPostContentEnd,
  CallSelectorsPostContentEnd
>({
  id: KEY_POST_CONTENT_END,
  url:
    ({ payload }) =>
    state => {
      const org = getCurrentOrganization(state);
      return API_POST_CONTENT_END(org as unknown as string, payload.contentId);
    },
  method: 'post',
  paramsSelector:
    ({ payload }) =>
    () => {
      return payload;
    },
  selectors: {
    data: ({ selectors }) => createSelector(selectors.response, res => res || undefined),
  },
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_POST_CONTENT_END : undefined,
});
